/**
 * Narrow view of the rp-auth prelead list, served to RP through
 * `/user-api/proxy/homematch/prelead/`. The upstream item carries the full
 * property payload — only the fields the teaser and the tinder deck read are
 * typed here.
 */

export enum HomematchPreleadStatus {
    PENDING = 1,
    REJECTED = 2,
    ACCEPTED = 3
}

/** Mirrors the values the backend PreleadRejectSerializer accepts. */
export enum HomematchRejectReason {
    UNFAVORABLE_LAYOUT = 1,
    NEIGHBORHOOD_EXPECTATIONS = 2,
    POOR_LOCATION = 3,
    TOO_EXPENSIVE = 4,
    OTHER = 5
}

interface IHomematchPreleadPropertyImage {
    /** Original S3 image — thumbnails are built from it with `getThumbnailLink`. */
    source_image_url?: string;
}

interface IHomematchPreleadOffer {
    name?: string;
    address?: string;
    images?: IHomematchPreleadPropertyImage[];
    vendor?: {
        name?: string;
        logo_thumbnails?: {
            v_log_100?: string;
        };
    };
}

export interface IHomematchPreleadListItem {
    id: number;
    status: HomematchPreleadStatus;
    property: {
        id: number;
        /** RP property id — the key for the property detail endpoint behind the proxy. */
        rp_id?: number | null;
        area?: number | null;
        rooms?: number | null;
        floor?: number | null;
        price?: number | null;
        price_m2?: number | null;
        images?: IHomematchPreleadPropertyImage[];
        offer?: IHomematchPreleadOffer;
    };
}

export interface IHomematchPreleadListResponse {
    count: number;
    results: IHomematchPreleadListItem[];
}
/**
 * Narrow view of the rp-auth prelead list, served to RP through
 * `/user-api/proxy/homematch/prelead/`. The upstream item carries the full
 * property payload — only the fields the teaser and the tinder deck read are
 * typed here.
 */

export enum HomematchPreleadStatus {
    PENDING = 1,
    REJECTED = 2,
    ACCEPTED = 3
}

/** Mirrors the values the backend PreleadRejectSerializer accepts. */
export enum HomematchRejectReason {
    UNFAVORABLE_LAYOUT = 1,
    NEIGHBORHOOD_EXPECTATIONS = 2,
    POOR_LOCATION = 3,
    TOO_EXPENSIVE = 4,
    OTHER = 5
}

interface IHomematchPreleadPropertyImage {
    /** Original S3 image — thumbnails are built from it with `getThumbnailLink`. */
    source_image_url?: string;
}

interface IHomematchPreleadOffer {
    name?: string;
    address?: string;
    images?: IHomematchPreleadPropertyImage[];
    vendor?: {
        name?: string;
        logo_thumbnails?: {
            v_log_100?: string;
        };
    };
}

export interface IHomematchPreleadListItem {
    id: number;
    status: HomematchPreleadStatus;
    property: {
        id: number;
        /** RP property id — the key for the property detail endpoint behind the proxy. */
        rp_id?: number | null;
        area?: number | null;
        rooms?: number | null;
        floor?: number | null;
        price?: number | null;
        price_m2?: number | null;
        images?: IHomematchPreleadPropertyImage[];
        offer?: IHomematchPreleadOffer;
    };
}

export interface IHomematchPreleadListResponse {
    count: number;
    results: IHomematchPreleadListItem[];
}
